import { cn } from "../../lib/utils.mjs";
import * as React from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/ui/code.tsx
const Code = React.forwardRef(function Code({ className, inline = false, children, ...props }, ref) {
	if (inline) return /* @__PURE__ */ jsx("code", {
		className: cn("rounded-xxxs bg-muted px-1.5 py-0.5 font-mono text-[0.85em] text-foreground", className),
		children
	});
	return /* @__PURE__ */ jsx("pre", {
		ref,
		className: cn("relative overflow-x-auto rounded-inset border bg-muted/40 p-4 font-mono text-xs leading-relaxed text-foreground", className),
		...props,
		children: /* @__PURE__ */ jsx("code", { children })
	});
});
//#endregion
export { Code };
